
import { styled } from '@mui/joy/styles';
import Grid from '@mui/joy/Grid';
import Sheet from '@mui/joy/Sheet';

import Logo from '../../assets/logo.svg'

//////////////Components
import FormLoginComponent from './Component/FormComponent';





export default function LoginPage() {
    return (
        <FormLoginComponent/>
    )
}